import { render, staticRenderFns } from "./ViewerFooter.vue?vue&type=template&id=aba9da12&scoped=true"
import script from "./ViewerFooter.vue?vue&type=script&lang=js"
export * from "./ViewerFooter.vue?vue&type=script&lang=js"
import style0 from "./ViewerFooter.vue?vue&type=style&index=0&id=aba9da12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba9da12",
  null
  
)

export default component.exports